// @flow
import React from "react";
import { toString, isFinite } from "lodash";
import formatSequencial from "@tvg/formatter/numeric";
import BeatenDistance from "../BeatenDistance";
import Position from "./styled-components";

type BeatenDistanceValues = {
  accBeatenDistance: string,
  accBeatenDistanceStatus: string
};

type Props = {
  finishPosition: number | null,
  numRunners: number,
  accBeatenDistance: BeatenDistanceValues
};

const getNonNumericPosition = (
  finishPosition: number | null,
  numRunners: number
) => {
  if (isFinite(finishPosition)) {
    // $FlowFixMe
    if (finishPosition <= 0) {
      return <Position nonNumeric>SCR</Position>;
    }
    return <Position nonNumeric>DNF</Position>;
  }

  return <Position nonNumeric>{`-/${numRunners}`}</Position>;
};

const getPosition = (
  finishPosition: number,
  numRunners: number,
  accBeatenDistance: BeatenDistanceValues
) => {
  const isWinner: boolean = finishPosition === 1;
  return (
    isFinite(finishPosition) && (
      <Position isWinner={isWinner}>
        {`${finishPosition}${formatSequencial(finishPosition).replace(
          toString(finishPosition),
          ""
        )}/${numRunners}`}
        <BeatenDistance
          beatenDistance={accBeatenDistance.accBeatenDistance}
          beatenDistanceStatus={accBeatenDistance.accBeatenDistanceStatus}
        />
      </Position>
    )
  );
};

const PositionInfo = ({
  finishPosition,
  numRunners,
  accBeatenDistance
}: Props) =>
  typeof finishPosition === "number" &&
  !!finishPosition &&
  finishPosition > 0 &&
  finishPosition <= +numRunners
    ? getPosition(finishPosition, numRunners, accBeatenDistance)
    : getNonNumericPosition(finishPosition, numRunners);

PositionInfo.defaultProps = {
  finishPosition: null,
  numRunners: 10,
  accBeatenDistance: {
    accBeatenDistance: "",
    accBeatenDistanceStatus: ""
  }
};

export default PositionInfo;
